// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"ee3ee5f436f0c49e65dd","453":"5468391bdec224d72661"}[chunkId] + ".js";
};